import { render, staticRenderFns } from "./SetupRule.vue?vue&type=template&id=133b73f0&scoped=true"
import script from "./SetupRule.vue?vue&type=script&lang=js"
export * from "./SetupRule.vue?vue&type=script&lang=js"
import style0 from "./SetupRule.vue?vue&type=style&index=0&id=133b73f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b73f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133b73f0')) {
      api.createRecord('133b73f0', component.options)
    } else {
      api.reload('133b73f0', component.options)
    }
    module.hot.accept("./SetupRule.vue?vue&type=template&id=133b73f0&scoped=true", function () {
      api.rerender('133b73f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/components/SetupRule.vue"
export default component.exports